import { TransactionTypeEnum } from 'app/models/transaction/transaction-type.enum';

export enum PaymentMethod {
  Cash = 'Cash',
  Card = 'Card',
  Xpay = 'Xpay',
}

export enum TransactionStatus {
  Paid = 'Paid',
  Pending = 'Pending',
  Failed = 'Failed',
}

export interface PaymentDetail {
  transactionDate: string;
  transactionTime: string;
  transactionType: TransactionTypeEnum;
  paymentMethod: string;
  partnerTransactionId: string;
  transactionAmount: string;
  transactionStatus: TransactionStatus;
  totalPaid: string;
  tricycleTransfer: string;
  terminalFee: string;
  boatTransfer: string;
  etrikeTransfer: string;
  environmentalFee: string;
  promo: string;
  amountPaid: string;
  convenienceFee: string;
}
